package com.devi3east.bashbuddy.account.profile.responses

import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.serialization.Serializable

@Serializable
data class UpdateProfileResponse(
    val modified: Boolean,
    val profile: Profile?
)